import {isNil} from 'ramda';

import {getSubscriptionId} from '../utils/getSubscriptionId';
import {NORMAL_CLOSE_CODE} from './subscriptionConstants';
import type {SubscriptionDeps, SubscriptionState} from './subscriptionTypes';

/**
 * Tears the subscription down: stops the reconnect loop, detaches the current
 * socket, sends the AppSync `stop` frame if the socket is still open, and
 * closes cleanly with code 1000.
 */
export const stopSubscription = (state: SubscriptionState, deps: SubscriptionDeps) => {
  state.isCleaningUp = true;
  clearTimeout(state.reconnectTimer);
  state.detachCurrentSocket?.();

  const socket = state.socket;
  if (isNil(socket)) {
    return;
  }

  if (socket.readyState === WebSocket.OPEN) {
    const subscriptionId = getSubscriptionId(deps.getState());
    socket.send(JSON.stringify({id: subscriptionId, type: 'stop'}));
  }

  socket.close(NORMAL_CLOSE_CODE);
};
